import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const container = css`
  max-width: 700px;
  padding: ${pxToRem(spacing.xxl)} ${pxToRem(spacing.sm)} ${pxToRem(spacing.xxxxl)};
  margin: 0 auto;
  text-align: center;
`;

export const imageWrapper = css`
  margin: ${pxToRem(spacing.xxl)} 0;

  img {
    max-width: 100%;
  }
`;

export const linksWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${pxToRem(spacing.sm)};

  ${mediaQuery(
    {
      min: minBreakpoints.M,
    },
    css`
      flex-direction: row;
    `,
  )}
`;
